export default __webpack_public_path__ + "static/Elido-Book-0b88ce33e728257eaf5cfdccbaa8f1a4.woff";